var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateRca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7296 5.7681C13.7296 5.7681 14.2296 6.2681 14.7296 7.2681C14.7296 7.2681 16.3186 4.7681 17.7296 4.2681M8.74456 0.7731C6.24556 0.6681 4.31556 0.9551 4.31556 0.9551C3.09656 1.0431 0.761556 1.7251 0.761556 5.7171C0.761556 9.6731 0.735556 14.5511 0.761556 16.4961C0.761556 17.6841 1.49656 20.4561 4.04256 20.6041C7.13756 20.7841 12.7126 20.8231 15.2706 20.6041C15.9546 20.5651 18.2346 20.0281 18.5226 17.5481C18.8226 14.9781 18.7626 13.1931 18.7626 12.7681",
    stroke: "#39ACE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73047 11.7695H9.73047M5.73047 15.7695H13.7305M20.7505 5.76953C20.7505 8.53053 18.5105 10.7695 15.7455 10.7695C15.0884 10.7702 14.4377 10.6413 13.8305 10.3904C13.2233 10.1394 12.6715 9.77119 12.2067 9.30684C11.7419 8.84248 11.3731 8.29106 11.1215 7.68411C10.87 7.07715 10.7405 6.42656 10.7405 5.76953C10.7405 3.00753 12.9815 0.769534 15.7455 0.769534C16.4025 0.768877 17.0532 0.897721 17.6604 1.1487C18.2676 1.39968 18.8194 1.76787 19.2842 2.23223C19.7491 2.69659 20.1178 3.24801 20.3694 3.85496C20.621 4.46191 20.7505 5.1125 20.7505 5.76953Z",
    stroke: "#39ACE7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateRca);
export default __webpack_public_path__ + "static/media/generate_rca.57ae787020710055ff98c2830cabf1eb.svg";
export { ForwardRef as ReactComponent };